export default __webpack_public_path__ + "static/media/qualification-icon.0cd43306.svg";